export default class Test {
  constructor() {
    alert('ok!');
  }

  alo() {
    alert('alo!');
  }
}
exports["default"] = Test;
module.exports = exports["default"];


// WEBPACK FOOTER //
// ./src/index.js